<!--
 * @Author: vince
 * @Date: 2021-09-03 14:20:46
 * @LastEditors: vince
 * @LastEditTime: 2021-09-05 16:04:03
 * @Description:
-->
<template>
	<div class="sys-box">
		<el-container style="height: 100%;">
			<el-aside width="200px">
				<el-menu :default-active="active" class="border-none" @select="menuSelect">
					<el-menu-item index="score1">
						<!-- <i class="el-icon-menu"></i> -->
						<span class="menu-label" slot="title">专业成效</span>
					</el-menu-item>
            <el-menu-item index="honor">
              <!-- <i class="el-icon-document"></i> -->
              <span class="menu-label" slot="title">教师荣誉</span>
            </el-menu-item>
            <el-menu-item index="selfApply">
              <!-- <i class="el-icon-document"></i> -->
              <span class="menu-label" slot="title">个人申报</span>
            </el-menu-item>
            <el-menu-item index="selfApplyAudit" v-if="power(userInfo.menuInfoList, 'selfApplyAudit')">
              <!-- <i class="el-icon-document"></i> -->
              <span class="menu-label" slot="title">申报审核</span>
            </el-menu-item>
            <el-menu-item index="auditorSet" v-if="power(userInfo.menuInfoList, 'auditorSet')">
              <!-- <i class="el-icon-document"></i> -->
              <span class="menu-label" slot="title">审核设置</span>
            </el-menu-item>
				</el-menu>
			</el-aside>

			<el-container>
				<el-header class="head">
					<span>{{title}}</span>
				</el-header>
				<el-main>
					<router-view></router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<style lang='less'>
</style>

<script>
import { mapState } from 'vuex'
import { power } from "@/utils/index.js";


export default {
	data() {
		return {};
	},
	methods: {
    power,
		menuSelect(index, indexPath) {
			this.$router.push({ name: index });
		}
	},
	computed: {
		...mapState(['userInfo']),
		title() {
			return this.$route.meta.title;
		},
		active() {
			return this.$route.name;
		},
		isAdmin() {
			return this.userInfo && this.userInfo.roleCodes && this.userInfo.roleCodes.includes('admin');
		}
	}
};
</script>
